export const DEFAULT_GCASH_AMOUNT = 2000;
export const DEFAULT_TOTAL_NUMBER_OF_REFERRALS = 15;
export const DAYS_TO_RETURN_TIME = 1000 * 60 * 60 * 24 * 14;
